import Header from "../components/Header";
import Hero from "../components/Hero";
import InfoGrid from "../components/InfoGrid";
import MyResearch from "../components/MyResearch";
import FeaturedPublications from "../components/FeaturedPublications";
import backgroundImage from "../assets/background.jpg"; // add your photo in /src/assets

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans mb-12">
            <Header />
            <section
              className="min-h-screen bg-cover bg-center pb-12"
              style={{ backgroundImage: `linear-gradient(rgba(199, 199, 199, 0.1), rgba(254, 254, 254, 0.05)), url(${backgroundImage})` }}
            >
              <div className="flex-1 flex items-center justify-center mb-10 pt-20">
                <Hero />
              </div>
              <div className="flex-1 flex items-center justify-center">
                <InfoGrid />
              </div>
            </section>
            <MyResearch />
            <FeaturedPublications />
    </div>
  );
}
